import { useEffect, useState } from 'react';
import { ANG_APIS } from '../../api.constants';
import SocietyTowerTabPanel from './SocietyTowerTabPanel';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { useParams } from 'react-router-dom';
import APIService from '../../../Services/APIService';

export default function SocietyInventoryDetails() {
  const errorMsg = false;
  const inventory_errorMsg = false;
  const count_errorMsg = false;
  const [tower, setTower] = useState();
  const [towerTabs, setTowerTabs] = useState([]);
  const [key, setKey] = useState('new');
  const { id } = useParams();

  const getTower = async () => {
    let res = await APIService.get(ANG_APIS.GET_TOWER);
    if (res.status == 200) setTower(res.data)
  };

  useEffect(() => {
    getTower();
  }, []);

  const handleNewClick = () => {
    let data = {
      id: '',
    };
    setTowerTabs([...towerTabs, data]);
  };

  return (
    <Tabs activeKey={key} onSelect={(k) => setKey(k)} className="mb-3">
      {towerTabs.length > 0 &&
        towerTabs.map((tab, key) => {
          return (
            <Tab eventKey={key} title={`Tower ${key}`}>
              <SocietyTowerTabPanel key={key} />
            </Tab>
          );
        })}
      <Tab eventKey="new" title="+New">
        <p onClick={handleNewClick}>New</p>
      </Tab>
    </Tabs>
  );
}
